import { getToken, returnError } from './helperFunc';
import { fetchNewsAction, fetchActiveNewsAction, createNewsAction, editNewsAction, deleteNewsAction } from './requestEndpoints';

const SET_NEWS_LOADING = 'SET_NEWS_LOADING';
const CLEAR_NEWS_ERROR = 'CLEAR_NEWS_ERROR';

const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS';
const GET_NEWS_FAIL = 'GET_NEWS_FAIL';

const GET_ACTIVE_NEWS_SUCCESS = 'GET_ACTIVE_NEWS_SUCCESS';
const GET_ACTIVE_NEWS_FAIL = 'GET_ACTIVE_NEWS_FAIL';

const CREATE_NEWS_SUCCESS = 'CREATE_NEWS_SUCCESS';
const CREATE_NEWS_FAIL = 'CREATE_NEWS_FAIL';

const UPDATE_NEWS_SUCCESS = 'UPDATE_NEWS_SUCCESS';
const UPDATE_NEWS_FAIL = 'UPDATE_NEWS_FAIL';

const DELETE_NEWS_SUCCESS = 'DELETE_NEWS_SUCCESS';
const DELETE_NEWS_FAIL = 'DELETE_NEWS_FAIL';

export const getNews = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_NEWS_ERROR });
    dispatch({ type: SET_NEWS_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await fetchNewsAction(token);
    dispatch({ type: GET_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_NEWS_FAIL, payload: returnError(error) });
  }
};

export const getActiveNews = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_NEWS_ERROR });
    dispatch({ type: SET_NEWS_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await fetchActiveNewsAction(token);
    dispatch({ type: GET_ACTIVE_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ACTIVE_NEWS_FAIL, payload: returnError(error) });
  }
};

export const createNews = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_NEWS_ERROR });
    dispatch({ type: SET_NEWS_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await createNewsAction(formData, token);
    dispatch({ type: CREATE_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_NEWS_FAIL, payload: returnError(error) });
  }
};

export const updateNews = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_NEWS_ERROR });
    dispatch({ type: SET_NEWS_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await editNewsAction(formData, token);
    dispatch({ type: UPDATE_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: UPDATE_NEWS_FAIL, payload: returnError(error) });
  }
};

export const deleteNews = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_NEWS_ERROR });
    dispatch({ type: SET_NEWS_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await deleteNewsAction({ id }, token);
    dispatch({ type: DELETE_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DELETE_NEWS_FAIL, payload: returnError(error) });
  }
};

const initialState = {
  loading: false,
  newsList: [],
  activeNews: [],
};

export const newsReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_NEWS_LOADING:
      return { ...state, loading: true };

    case CLEAR_NEWS_ERROR:
      return { ...state, error: null };

    case GET_NEWS_SUCCESS:
      return { ...state, newsList: action.payload.data, loading: false, error: null };

    case GET_ACTIVE_NEWS_SUCCESS:
      return { ...state, activeNews: action.payload.data, loading: false, error: null };

    case CREATE_NEWS_SUCCESS:
      return { ...state, newsCreated: action.payload.data, loading: false, error: null, success: true };

    case UPDATE_NEWS_SUCCESS:
      return { ...state, newsUpdated: action.payload.data, loading: false, error: null, success: true };

    case DELETE_NEWS_SUCCESS:
      return { ...state, loading: false, error: null, removed: true };

    case GET_NEWS_FAIL:
    case GET_ACTIVE_NEWS_FAIL:
    case CREATE_NEWS_FAIL:
    case UPDATE_NEWS_FAIL:
    case DELETE_NEWS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default newsReducer;
